<!--
*@description：toolBar组件
*@author:rzl
*@date:2021/5/24 13:45
-->
<template>
    <div  class="search-bar ant-row">
      <a-select
          v-model:value="roleState"
          placeholder="禁用状态"
          class="search-item ant-col-4">

        <a-select-option v-for="(item) in searchOptions" :key="item.key">
          {{ item.value }}
        </a-select-option>
      </a-select>
      <a-input class="search-item ant-col-4" v-model:value="queryText"  placeholder="请输入关键字" />
      <a-button class="search-item" type="dashed" shape="circle" @click="doSearch">
        <template #icon><Search /></template>
      </a-button>
      <a-button class="search-item" type="dashed" shape="circle" @click="refresh">
        <template #icon><Reset /></template>
      </a-button>
      <a-button class="search-item" type="dashed" shape="circle" @click="addData">
        <template #icon><Add /></template>
      </a-button>

    </div>
</template>

<script>
    import Icons from "../../../../components/Icons";

    export default {
        name: "userToolBar",
        mixins:[Icons],
        data(){
          return{
            searchOptions:[
              {key:0,value:"禁用"},
              {key:1,value:"启用"},
            ],
            queryText:null,
            roleState:null
          }
        },
        methods:{
          doSearch(){
            let data = this.$GetEmitData(this.$eventTags.search,{roleState:this.roleState,name:this.queryText});
              this.$emit("event",data);
          },
          refresh(){
            this.queryText = null;
            this.roleState = null;
            this.$emit("event",this.$GetEmitData(this.$eventTags.refresh));
          },
          addData(){
            this.$emit("event",this.$GetEmitData(this.$eventTags.add));
          },
          getParms(){
            let parms = {
              queryText:this.queryText,
              roleState:this.roleState,
            }
            return parms;
          },
        }
    }
</script>

<style scoped>

</style>